<template>
  <section id="section-3" class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <div class="content-current">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group inputContainer">
            <label>از تاریخ </label>
            <div class="icon-position">
              <i class="icon_calendar icon"></i>
            </div>
            <input
              type="text"
              class="form-control"
              v-datepicker="{ maxDate: now }"
              :value="convertDate(fromDate)"
              @change="fromDate = $event.detail.GregorianDate"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group inputContainer">
            <label>تا تاریخ</label>
            <div class="icon-position">
              <i class="icon_calendar icon"></i>
            </div>
            <input
              type="text"
              class="form-control"
              v-datepicker="{ maxDate: now }"
              :value="convertDate(toDate)"
              @change="toDate = $event.detail.GregorianDate"
            />
          </div>
        </div>
    
      </div>
   
    </div>
    <hr />
    <div class="col-md-12 loading" v-if="isLoading">
      <loadingBar type="ripple" />
    </div>
    <table
      class="table tablesorter  add_bottom_30"
      v-if="!isLoading"
    >
      <thead class="thead-light"> 
        <tr>
          <th>شماره رزرو </th>
          <th>تاریخ </th>
          <th>نام مهمان</th>
          <th>فروشنده </th>
          <th>ورود </th>
          <th>خروج</th>
          <th>کاهش</th>
        
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in creditList">
          <tr
            @click="toggle(index + 1)"
            :class="{ opened: opened.includes(index + 1) }"
          >
            <td>{{ item.sourceName }}</td>
            <td>{{ item.date | persianDate("jYYYY/jMM/jDD") }}</td>
            <td v-if="item.status == 'Success'">موفق</td>
            <td v-if="item.status != 'Success'">ناموفق</td>
            <td>{{ item.requestCode }}</td>
            <td>{{ item.referenceCode }}</td>
            <td>{{ item.credit | numFormat }}</td>
            <td>{{ item.debt | numFormat }}</td>
            <td>{{ parseInt(item.balance) | numFormat }}</td>
          </tr>

          <tr v-if="opened.includes(index + 1)">
            <td class="td-opened" colspan="6">
              توضیحات : {{ item.description }}
            </td>
            <td class="td-opened" colspan="5">
              نوع سرویس : {{ item.serviceType }}
            </td>
          </tr>

          <tr v-if="opened.includes(index + 1)">
            <td class="td-opened" colspan="6">کاربر : {{ item.userName }}</td>
            <td class="td-opened" colspan="5">کدآژانس : {{ item.sourceId }}</td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="btn-align">
      <h3 v-if="!hasShowResult">نتیجه ای یافت نشد !!!!</h3>
    </div>
  </section>
</template>

<script>
import Store from "../../../../views/profile/store/index";
import moment from "moment-jalaali";
import loadingBar from "../../../../components/loading/pdkLoadingBar";

export default {
  name: "creditReport",
  store: Store,
  components: { loadingBar },
  data() {
    return {
      now: moment(),
      isLoading: false,
      opened: [],
      sourceList: [],
      creditList: [],
      sourceProfileId: "",
      fromDate: new Date(),
      toDate: new Date(),
      isAdmin: false,
      referenceCode: "",
      requestCode: "",
      contentVisible: false,
      hasShowResult: false,
    };
  },
  created() {
    this.getSourceList();
    this.search();
  },

  methods: {
    convertDate(date) {
      if (date === "0001-01-01T00:00:00") return "";
      if (!moment(date).isValid()) return "";
      const pdate = moment(date).format("jYYYY/jMM/jDD");
      return pdate;
    },
 
    search() {
    
    },
    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(id);
      }
    },
  },
};
</script>

<style scoped>
/* Bootstrap.css */
@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
}
.page-link {
  position: relative !important;
  display: block !important;
  padding: 0.5rem 0.75rem !important;
  margin-left: -1px !important;
  line-height: 1.25 !important;
  color: #2a69b1 !important;
  background-color: #fff !important;
  border: 1px solid #dee2e6 !important;
}
.page-link:hover {
  z-index: 2;
  color: #0056b3 !important;
  text-decoration: none !important;
  background-color: #e9ecef !important;
  border-color: #dee2e6 !important;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
  background-color: #2a69b1 !important;
  border-color: #2a69b1 !important;
}
.btn-profile {
  width: 180px !important;
}
.btn-align {
  /* text-align: center; */
  margin-top: 20px !important;

  /* padding-right: 70px !important;
  padding-left: 70px !important; */
}
.icon-top {
  margin-top: 38px;
  font-size: 40px;
}
.icon-bottom {
  margin-top: 38px;
  font-size: 22px;
}
.icon-position {
  float: left;
  margin-left: 26px;
}
/* .opened {
  background-color: yellow;
} */
.td-opened {
  background-color: rgb(4 112 167) !important;
  color: white;
}
.loading {
  height: 1000px !important;
  text-align: center !important;
  margin-top: 200px !important;
}
h3 {
  color: #777 !important;
}
</style>